module.exports = __webpack_public_path__ + "static/media/c200-banner.400dde53.png";